export class NICETimeZone
{
    displayName: string;
    standardName: string;
    offset: string;

    constructor(niceScript?)
    {
        if (niceScript != null) {
            this.displayName = niceScript.displayName;
            this.standardName = niceScript.standardName;
            this.offset = niceScript.offset;
        }
    }
}
